

























































































import Vue from "vue";
import TarifCovidLayout from "@/@modules/tarif-covid/components/Layout.vue";
import Filters from "./Filters.vue";
import { GraphqlService } from "../../services";
import { DataTableHeader } from "vuetify";
import { FinancialFlow } from "../../interfaces/FinancialFlow";
export default Vue.extend({
  components: {
    TarifCovidLayout,
    Filters,
  },
  data() {
    return {
      payments: [] as FinancialFlow[],
      pagination: {} as any,
      delay: undefined as any,
      filters: {
        nihii: undefined,
        cbe: undefined,
        ssin: undefined,
        state: [],
        period: undefined,
        iban: undefined,
        cashingDateFrom: undefined,
        cashingDateTo: undefined,
      } as any,
      totalElements: 0,
      loading: true,
      headersConfig: [
        { text: "tarif-covid.inamiNbr", value: "inamiNbr", sortable: false },
        { text: "tarif-covid.nationalRegisterNbr", value: "ssin", sortable: false },
        { text: "tarif-covid.cbeNbr", value: "bceNbr", sortable: false },
        { text: "tarif-covid.lastName", value: "lastName", sortable: false },
        { text: "tarif-covid.firstName", value: "firstName", sortable: false },
        { text: "tarif-covid.paymentDate", value: "date", sortable: false },
        { text: "tarif-covid.period", value: "period", sortable: false },
        { text: "tarif-covid.paymentAmount", value: "amount", sortable: false },
        { text: "tarif-covid.paymentNbr", value: "paymentNbr", sortable: false },
        { text: "tarif-covid.iban", value: "iban", sortable: false },
        { text: "tarif-covid.communication", value: "communication", sortable: false },
        { text: "tarif-covid.paymentStatus", value: "state", sortable: false },
        { text: "tarif-covid.rejectReason", value: "rejectReason", sortable: false },
        { text: "", value: "actions", sortable: false },
      ] as DataTableHeader[],
    };
  },
  watch: {
    pagination: {
      handler() {
        clearTimeout(this.delay);
        this.delay = setTimeout(() => {
          this.refresh();
        }, 500);
      },
      deep: true,
    },
  },
  mounted() {
    this.refresh();
  },
  computed: {
    flatPayments(): any {
      return this.payments.map(payment => {
        return {
          inamiNbr: payment.workerVC?.worker?.nihii,
          ssin: payment.workerVC?.worker?.nativeWorker?.ssin,
          bceNbr: payment.nativeWorker?.cBE,
          lastName: payment.nativeWorker?.lastName,
          firstName: payment.nativeWorker?.firstName,
          date: payment.cashingDate?.toLocaleDateString(),
          period: `20${payment.workerVC?.exercise}`,
          amount: payment.amount,
          paymentNbr: payment.paymentNr,
          iban: payment.foreignBankAccount?.iban,
          communication: payment.communication,
          state: payment.state,
          rejectReason: payment.returnMotivation,
        };
      });
    },
  },
  methods: {
    async refresh() {
      this.loading = true;
      this.payments = await GraphqlService.getFinancialFlows(
        this.filters.ssin,
        this.filters.cbe,
        this.filters.nihii,
        this.filters.state.length > 0 ? this.filters.state : undefined,
        this.filters.iban,
        this.filters.cashingDateFrom ? new Date(this.filters.cashingDateFrom) : undefined,
        this.filters.cashingDateTo ? new Date(this.filters.cashingDateTo) : undefined,
        this.pagination.itemsPerPage,
        (this.pagination.page - 1) * this.pagination.itemsPerPage
      );
      this.totalElements =
        this.payments.length % this.pagination.itemsPerPage == 0
          ? this.pagination.page * this.pagination.itemsPerPage + 1
          : this.pagination.page - 1 + this.payments.length;
      this.loading = false;
    },
    redirect(item: any) {
      this.$router.push("/payments/details?ssin=" + item.ssin);
    },
  },
});
